import React from 'react';
import { Link } from 'react-router-dom';
import ZoeaLogo from '@/components/ZoeaLogo';
import { FOOTER, HERO, NAV_LINKS } from './landingCopy';
import { contactMailto, getContactEmail } from './landingConfig';

const PRIVACY_URL = process.env.REACT_APP_PRIVACY_URL || '';
const TERMS_URL = process.env.REACT_APP_TERMS_URL || '';

export const LandingHeader = () => (
  <header className="zl-header">
    <div className="zl-wrap zl-header-row">
      <a href="#top" className="zl-logo" aria-label="Zoea, naar boven">
        <ZoeaLogo className="h-[34px]" />
      </a>
      <nav className="zl-nav" aria-label="Hoofdnavigatie">
        {NAV_LINKS.map((link) => <a key={link.href} href={link.href}>{link.label}</a>)}
      </nav>
      <div className="zl-header-actions">
        <Link to="/login" className="zl-login" data-testid="login-btn">Inloggen</Link>
        <a href="#kennismaking" className="zl-btn zl-btn-primary" data-testid="header-cta">{HERO.headerCta}</a>
      </div>
    </div>
  </header>
);

export const LandingFooter = () => {
  const email = getContactEmail();
  return (
    <footer className="zl-footer">
      <div className="zl-wrap zl-footer-row">
        <a href="#top" className="zl-logo" aria-label="Zoea, naar boven">
          <ZoeaLogo inverted className="h-[34px]" />
        </a>
        <nav aria-label="Voettekst">
          <a href="#tour">Producttour</a>
          <a href="#vragen">Vragen</a>
          <a href="#kennismaking">{HERO.headerCta}</a>
          <Link to="/pricing">Prijsinformatie</Link>
          <Link to="/login">Inloggen</Link>
          {PRIVACY_URL && <a href={PRIVACY_URL}>Privacy-informatie</a>}
          {TERMS_URL && <a href={TERMS_URL}>Voorwaarden</a>}
        </nav>
        <p>
          {FOOTER.tagline}
          {email && <> · <a href={contactMailto(email)} data-testid="footer-email">{email}</a></>}
        </p>
      </div>
    </footer>
  );
};
